export const STALE_TIME_XXS = 10 * 1000; // 10 seconds — for volatile shared state (e.g. bookable meeting slots)
export const STALE_TIME_LIST = 30 * 1000; // 30 seconds — for operational lists that agents act on
export const STALE_TIME_SM = 10 * 60 * 1000; // 10 minutes
export const STALE_TIME_MD = 60 * 60 * 1000; // 1 hour
export const STALE_TIME_LG = 12 * 60 * 60 * 1000; // 12 hours
